// extracted by mini-css-extract-plugin
export var center = "_1y-2";
export var clickableRow = "_1y-5";
export var expandedRow = "_1y-7";
export var hoverable = "_1y-4";
export var left = "_1y-1";
export var right = "_1y-3";
export var row = "_1y-0";
export var selectedRow = "_1y-6";
export var summaryRow = "_1y-8";